import { useCallback, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ModalFormContext from "../../store/ModalFormContext";
import useForm from "./use-form";
import i18n from "../../i18n";
import UserContext from "../../store/UserContext";

const usePostForm = (applyData = () => {}) => {
  const navigate = useNavigate()
  const userContext = useContext(UserContext)
  const modalFormContext = useContext(ModalFormContext);

  
  const handleUpdateStatus = useCallback((data) => {
    if(!data.valid){
        modalFormContext.dispatchForms({type:'SET_FORM', forms:[data]})
        modalFormContext.callBackFunc = applyData
        modalFormContext.openModal();
    }
    else if(data.redirect_url){
      modalFormContext.openModal()
      if(data.redirect_url.startsWith('/rest/')){
        modalFormContext.setModalForm({url:data.redirect_url});
      }
      else if(data.redirect_url == window.location.pathname){
        if(modalFormContext.call_back_func){
          throw new Error('call_back_func is deprecated, use callbackFunc instead')
        }
        if(modalFormContext.callbackFunc){
          modalFormContext.callbackFunc()
        }
        modalFormContext.closeModal()
      }
      else if(data.open_new_window){
        window.open(data.redirect_url, '_blank')
        // navigate(data.redirect_url)
      }
    } 
    else if(data.navigate_url && data.open_new_window){
      // Try to open in new window
      const newWindow = window.open('', '_blank');
      if (newWindow) {
          // Popup was allowed
          newWindow.location.href = data.navigate_url;
          newWindow.focus();
      } else {
          // Popup was blocked - show a message and provide a link
          modalFormContext.openModal()
          const message = document.createElement('span');
          message.textContent = i18n.t('Popup was blocked. Click the link below to continue:');
          const link = document.createElement('a');
          link.href = data.navigate_url;
          link.target = '_blank';
          link.textContent = i18n.t('Continue here');
          link.className = 'btn btn-primary mt-2';
          const place = document.getElementById('form-modal-content').getElementsByClassName('forms-wrapper')[0]
          place.innerHTML = '';
          place.appendChild(message);
          place.appendChild(link);
      }
    }
    else if(data.navigate_url){
        navigate(data.navigate_url.replace('/rest/', '/form/'))
    }
    if(data.valid && data.save_status_code === 4 && !data.redirect_url){
      userContext.setMessages({type: 'success', message: i18n.t("Succesfully saved ") + data.instance})
      applyData(data)
    }else{
      if(data.message){
        userContext.setMessages({type: 'info', message: data.message})

      }
    }
  }, [])
  const { isLoading, error, sendRequest: sendRequestForm} = useForm(handleUpdateStatus);

  const sendRequest = useCallback((url, data) => {
    sendRequestForm({ url: url, method: "POST", data: data, json: true });
  }, [sendRequestForm]); 

  useEffect(() => {
    if(error){
      userContext.setMessages({type: 'error', message: error})
    }
  }, [error])

  return { isLoading, error, sendRequest };
};

export default usePostForm;
